import { Component, OnInit,Renderer,ElementRef,  HostListener } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
@Component({
  selector: 'client-messaging-key-value',
  templateUrl: './client-messaging.component.html',
  styleUrls: ['./client-messaging.component.scss']
})
export class ClientMessagingComponent implements OnInit {
  modalHeader: string;
  modalContent: string;
  target;
  showCancelButton = false;
  showSaveButton = false;
  public isBodyScrollable:boolean=false;
  htmlForm: FormGroup;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
      if(!this.isBodyScrollable)
        this._renderer.setElementStyle(document.body, 'overflow', 'hidden');
      else{
        this._renderer.setElementStyle(document.body, 'overflow', 'unset');
      }
    }else{
      if(!this.isBodyScrollable)
        this._renderer.setElementStyle(document.body, 'overflow', 'hidden');
      else{
        this._renderer.setElementStyle(document.body, 'overflow', 'unset');
      }
    }
}
  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private _renderer: Renderer,
    private eRef: ElementRef,
    private fb: FormBuilder
  ) { 
    this.initializeForm();
  }

  ngOnInit() {
  }

  initializeForm(){    
    this.htmlForm = this.fb.group({
      'sampFiles': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
    });
  }
  closeModal() {
    this.activeModal.close();
    return false;
  }
  successModal() {
    console.log("clicked on ok");
    this.activeModal.close();
  }

  cancelModal() {
    console.log("clicked on abort");
    this.activeModal.close();
  }

  public ngOnDestroy():void{
    // this.isBodyScrollable = true;
    this._renderer.setElementStyle(document.body, 'overflow', 'unset');
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/shared/components/client-messaging-key-value/client-messaging.component.ts